export default __webpack_public_path__ + "static/media/spiritedaway.1b25dfa6.png";